// Delivery date
(function () {

  // addEventListener for multiple elements
  function on(nodes, callback, event) {
    for (var i = 0, l = nodes.length; i < l; i++) {
      nodes[i].addEventListener(event || 'click', callback);
    }
  }

  function getInventoryQuantity(variants, variantIdFromURL, defaultInventoryQuantity) {
    if (!variantIdFromURL) return defaultInventoryQuantity;
    var currentVariant = variants.find(function (variant) {
      return variant.id === variantIdFromURL;
    });
    if (!currentVariant) return defaultInventoryQuantity;
    return currentVariant.inventory_quantity;
  }

  function getVariantIdFromURL() {
    var queryString = window.location.search;
    if (!queryString) return null;
    var matching = queryString.match(/variant=(\d+)/);
    if (!matching) return null;
    return matching[1];
  }

  function getPostPreOrderDate(days) {
    var preOrderNode = document.querySelector('.PreOrder__message span');
    if (!preOrderNode) return null;
    var preOrderDateString = preOrderNode.textContent.trim();
    if (!preOrderDateString.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) return null;
      if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(preOrderDateString)) {
    return null;
  }
    var preOrderDate = new Date(preOrderDateString);
    preOrderDate.setDate(preOrderDate.getDate() + days);
    return preOrderDate.toLocaleDateString();
  }

  function getESTDay(dateObject) {
    var UTCDay = dateObject.getUTCDay();
    var UTCHours = dateObject.getUTCHours();
    // 5 is a difference in hours between UTC and EST
    if (UTCHours - 5 >= 0) return UTCDay;
    // Otherwise, EST day is the previous in comparison with UTC
    // Special case: 0 is the index of Sunday, 6 - of Saturday
    if (UTCDay === 0) return 6;
    return UTCDay - 1;
  }

  function getESTHours(dateObject) {
    var UTCHours = dateObject.getUTCHours();
    // 5 is a difference in hours between UTC and EST
    if (UTCHours - 5 >= 0) return UTCHours - 5;
    return 24 - (5 - UTCHours);
  }

  function getHoursLeft(cutoffTime, ESTDay, ESTHours) {
    var fridayCutoffTime = 14;
    if (ESTDay === 1 || ESTDay === 2 || ESTDay === 3) {
      if (ESTHours < cutoffTime) return cutoffTime - ESTHours;
      return 24 - (ESTHours - cutoffTime);
    }
    if (ESTDay === 4) {
      if (ESTHours < cutoffTime) return cutoffTime - ESTHours;
      return 24 - (ESTHours - fridayCutoffTime);
    }
    if (ESTDay === 5) {
      if (ESTHours < fridayCutoffTime) return fridayCutoffTime - ESTHours;
      // The next cut-off time is on Monday
      if (ESTHours < cutoffTime) return cutoffTime - ESTHours + 72;
      return 24 - (ESTHours - cutoffTime) + 48;
    }
    if (ESTDay === 6) {
      if (ESTHours < cutoffTime) return cutoffTime - ESTHours + 48;
      return 24 - (ESTHours - cutoffTime) + 24;
    }
    // Sunday
    if (ESTDay === 0) {
      if (ESTHours < cutoffTime) return cutoffTime - ESTHours + 24;
      return 24 - (ESTHours - cutoffTime);
    }
  }

  function getAdditionalDays(cutoffTime, ESTDay, ESTHours) {
    var fridayCutoffTime = 14;
    if (ESTDay === 1 || ESTDay === 2 || ESTDay === 3 || ESTDay === 4) {
      return ESTHours < cutoffTime ? 0 : 1;
    }
    if (ESTDay === 5) {
      return ESTHours < fridayCutoffTime ? 0 : 3;
    }
    if (ESTDay === 6) {
      return 2;
    }
    // Sunday
    if (ESTDay === 0) {
      return 1;
    }
  }

  function getText(dataFromDB) {


      if (!dataFromDB || typeof dataFromDB !== 'object' || !dataFromDB.days) {
    return '';  // No valid data, return empty
  }
    if (dataFromDB.isMilitary) return ''
      + 'APO & FPO addresses are military installations around the globe both international and domestic. '
      + 'Orders to these addresses can only be shipped with the United States Postal Service. '
      + 'Shipping to APO & FPO addresses with USPS can take up to 30 days in transit before receipt. '
      + 'We are unable to expedite this shipping service.';
    var days = dataFromDB.days;
    if (dataFromDB.isPreOrder) {
      var postPreOrderDate = getPostPreOrderDate(days);
      return postPreOrderDate ? 'Estimated delivery by ' + postPreOrderDate : '';
    }
    // + 12 is for 24 hours format
    var cutoffTime = dataFromDB.cutoffTime + 12;
    var date = new Date();
    var ESTDay = getESTDay(date);
    var ESTHours = getESTHours(date);
    var hoursLeft = getHoursLeft(cutoffTime, ESTDay, ESTHours);
    var additionalDays = getAdditionalDays(cutoffTime, ESTDay, ESTHours);
    date.setDate(date.getDate() + days + additionalDays);
    var deliveryDate = date.toLocaleDateString();
    return 'Order in the next ' + hoursLeft + ' hours for estimated delivery by ' + deliveryDate;
  }

  function setText(vendor, state) {
    var dataFromDB = CustomDB2.DeliveryDate.get(vendor, state.inventoryQuantity, state.country, state.ZIP);
    document.querySelector('.DeliveryDate__text').innerHTML = getText(dataFromDB);
  }

  function main() {
    var componentNode = document.querySelector('.DeliveryDate');
    // If not product page
    if (!componentNode) return;
    var countryButtons = document.querySelectorAll('#popover-delivery-date .Popover__ValueList button');
    var inputZIP = document.querySelector('.DeliveryDate__inputZIP');
    var vendor = componentNode.getAttribute('data-vendor');
    var variants = JSON.parse(componentNode.querySelector('script').textContent);
    var defaultInventoryQuantity = parseInt(componentNode.getAttribute('data-default-inventory-quantity'), 10) || 0;
    // Variables that can change by user
    var state = {
      inventoryQuantity: null,
      country: '',
      ZIP: '',
    };

    function handleCountryButtonClick(event) {
      var country = event.target.getAttribute('data-value');
      inputZIP.style.display = country === 'United States' ? 'inline' : 'none';
      state.country = country;
      setText(vendor, state);
    }

    on(countryButtons, handleCountryButtonClick);

    function handleInputZIPChange() {
      var zip = inputZIP.value.trim();
  if (!/^\d{5}(-\d{4})?$/.test(zip)) {  
    return;
  }
  state.ZIP = zip;
  setText(vendor, state);
    }

    inputZIP.addEventListener('input', handleInputZIPChange);

    var variantIdCached = null;

    function listenToVariantChange() {
      var variantIdFromURL = getVariantIdFromURL();
      // If the variant hasn't changed
      if (variantIdFromURL === variantIdCached) return;
      variantIdCached = variantIdFromURL;
      var inventoryQuantity = getInventoryQuantity(variants, variantIdFromURL, defaultInventoryQuantity);
      // If inventory quantity is 0
      if (!inventoryQuantity) {
        componentNode.style.display = 'none';
        return;
      };
      componentNode.style.display = 'block';
      state.inventoryQuantity = inventoryQuantity;
      setText(vendor, state);
    }

    window.setInterval(listenToVariantChange, 500);
  }

  try {
    main();
  } catch (error) {}
}());
